export default __webpack_public_path__ + "static/media/Guestbooknewmessage.c83c90dc.PNG";